import React,{useState,useEffect} from 'react'
import {Form,Col,Container,Table,Button} from 'react-bootstrap';
import scale from './seadl_data.json';

function AnswerField(props){
    const [value,setValue] = useState(props.data!=null?props.data:"None")
    const onChange =(event) =>{
        
        setValue(event.target.value)
        props.handler(event)
        
    }
    
   
    return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={onChange} name={'rating'} value={value} disabled={props.disabled}>
                        {scale.map((s,index) =>(
                            <option key={index} desc={s.desc}>{s.rating}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
}
class Seadl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {description:"None"}
        this.onChange = this.onChange.bind(this)
    }
    async handleDesc(){

    }
    async onChange(event){
        const {name, value,selectedIndex} = event.target
        await this.setState((prevState)=>({
            ...prevState,
            [name]: value,
            description:scale[selectedIndex].desc
        }))
        this.props.handler('seadl',this.state)
        
    }
    componentDidMount(){
      if(this.props.data!=null){
          this.setState(this.props.data)
      }
    }
    // componentDidUpdate(prevProps, prevState){
    //     if (prevState!= this.state){
    //         this.props.handler('seadl',this.state)
    //     }
    // }

    render(){
        return (
            <Container>
                <h3 style={{textAlign: 'center'}}>Schwab and England Activites of Daily Living Scale</h3>
                <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                    <thead>
                        <tr>
                            <th>Rating</th>
                            <th style={{textAlign: 'center'}}>Description of ADL capability</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><AnswerField handler={this.onChange} disabled={this.props.disabled} data={this.props.data!=null?this.props.data['rating']:null}/></td>
                            <td style={{textAlign: 'center'}}>{this.state.description}</td>
                        </tr>
                    </tbody>

                </Table>
            </Container>
        )
    }
}
Seadl.defaultProps = {
    data:null,
    disabled:false
}
export default Seadl;